import {onClick, inViewport} from '../abstract/helpers.js';

export class ImpactSlider {
  constructor() {

    

    
    if(document.querySelector('#stories-of-change')) {

      let List = document.querySelectorAll('#stories-of-change .card-wrapper .year-warpper ul li span');
      List.forEach(function(el) {

        onClick(el, function (e) {
          e.preventDefault();
          
          let year = el.getAttribute('data-year')

          if(document.querySelector('#stories-of-change .year-' +year)) {
            this.scrollToSmoothly(document.querySelector('#stories-of-change .year-' +year).offsetTop-160, 500)
          }

        }.bind(this));
      }.bind(this));

      /*
      
      window.addEventListener('scroll', function(event) { 
        let el = document.querySelectorAll('#stories-of-change .impact-story-card');
        console.log(el);
        let primaryElement = false;
        el.forEach(function(p) {

          inViewport(p, function(e) {
            if(e && !p) {
              primaryElement = p;
            }
          }.bind(p));

        });
        
        p.classList.add('active');

      });

      */

    }
  }

  scrollToSmoothly(pos, time) {
    var currentPos = window.pageYOffset;
    var start = null;
    if(time == null) time = 500;
    pos = +pos, time = +time;
    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        var progress = currentTime - start;
        if (currentPos < pos) {
            window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
        } else {
            window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
        }
        if (progress < time) {
            window.requestAnimationFrame(step);
        } else {
            window.scrollTo(0, pos);
        }
    });
  }
}


